import { createSlice } from '@reduxjs/toolkit';

import type { PartnerInsightsState } from './types';

export const initialState: null = null;

export const { actions, reducer } = createSlice({
  name: 'partnerInsights',
  initialState: initialState as PartnerInsightsState | null,
  reducers: {},
});
